
import { Loader2 } from 'lucide-react';

const ProfileLoading = () => {
  return (
    <div className="bg-adv-dark min-h-screen flex items-center justify-center">
      <div className="text-center">
        <Loader2 size={48} className="text-adv-orange animate-spin mb-4 mx-auto" />
        <p className="text-white text-lg">Loading profile...</p>
      </div>
    </div>
  );
};

export default ProfileLoading;
